export class Tipo_cargo{
  constructor(
     public id: string,
     public cargo: string,
     public id_estado:any
  ){
  }
}
